import { render, staticRenderFns } from "./LoginSignupForm.vue?vue&type=template&id=2c9dcb20&scoped=true"
import script from "./LoginSignupForm.vue?vue&type=script&lang=js"
export * from "./LoginSignupForm.vue?vue&type=script&lang=js"
import style0 from "./LoginSignupForm.vue?vue&type=style&index=0&id=2c9dcb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dcb20",
  null
  
)

export default component.exports